import { useTranslation } from "react-i18next";

interface Language {
  id: number;
  value: string;
  text: string;
}

export const useProfileLanguages = (): Language[] => {
  const { t } = useTranslation();

  return [
    {
      id: 1,
      value: "ru",
      text: t("language-ru"),
    },
    {
      id: 2,
      value: "uz",
      text: t("language-uz"),
    },
    // {
    //   id: 3,
    //   value: "en",
    //   text: t("language-en"),
    // },
  ];
};
